enum AppPath {
  Root = '/',
  Orders = '/orders',
  Customers = '/customers',
  Products = '/products',
  Inventory = '/inventory',
  Settings = '/settings',
  Bookings = '/bookings',
  Bookings_Services = '/bookings/services',
  Payments = '/payments',
  Checkout = '/checkout',
  Invoices = '/invoices',

  /**
   * Settings
   */
  Settings_FulfilmentProviders = '/settings/fulfilment-providers',
  Settings_UserSettings = '/settings/user-settings',
  Settings_UsersManagement = '/settings/users-management',
  Settings_PaymentProcessors = '/settings/payment-processors',
  Settings_ShippingProviders = '/settings/shipping-providers',

  /**
   *
   * Shipping Profiles
   *
   */
  Shipping = '/shipping',
  Shipping_Profiles = '/shipping/shipping-profiles',
}

enum AuthPath {
  Login = '/login',
}

export { AppPath, AuthPath };
